// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanUpdate } from "./hook";

export type CanUpdateProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanUpdate({ children, fallback, scope }: CanUpdateProps) {
  const canDoAction = useCanUpdate(scope);
  return <>{canDoAction ? children : fallback}</>;
}
